import React from 'react'

import { Card, CardContent, Container, Grid } from '@material-ui/core'
import moment from 'moment'
import CountUp from 'react-countup'

import City from '~/assets/color-icons/city.svg'
import Country from '~/assets/color-icons/country.svg'
import State from '~/assets/color-icons/state.svg'
import ResidentLogo from '~/assets/resident_logo_blue.svg'
import translate from '~/locale'

import '~/styles/custom/residentNumbers.scss'

const ResidentNumbers: React.FC = () => {
  const launchDate = moment('2021-2-11')
  const now = moment()
  const duration = moment.duration(launchDate.diff(now))

  return (
    <div className="bg-content resident-numbers pt-1 pt-sm-4">
      <Container className="py-1 pt-lg-6">
        <div className="resident-numbers-content">
          <Grid container spacing={6}>
            <Grid item md={6} lg={3}>
              <Card className="mb-5 card-box card-box-border-bottom border-blue">
                <CardContent>
                  <div className="text-center">
                    <div className="mt-1">
                      <ResidentLogo className="font-size-xxl text-success" />
                    </div>
                    <div className="mt-3 line-height-sm">
                      <span className="text-black-50">
                        {translate('available_in_canada')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3}>
              <Card className="mb-5 card-box card-box-border-bottom border-danger">
                <CardContent>
                  <div className="text-center">
                    <div className="mt-1">
                      <Country className="font-size-xxl text-danger" />
                    </div>
                    <div className="mt-3 line-height-sm">
                      <b className="font-size-lg pr-1">
                        <CountUp
                          start={0}
                          end={13}
                          duration={5}
                          delay={2}
                          separator=","
                          decimals={0}
                          decimal=","
                        />
                      </b>
                      <span className="text-black-50">
                        {translate('state/provinces')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3}>
              <Card className="mb-5 card-box card-box-border-bottom border-warning">
                <CardContent>
                  <div className="text-center">
                    <div className="mt-1">
                      <State className="font-size-xxl text-warning" />
                    </div>
                    <div className="mt-3 line-height-sm">
                      <b className="font-size-lg pr-1">
                        <CountUp
                          start={0}
                          end={3173}
                          duration={10}
                          delay={2}
                          separator=","
                          decimals={0}
                          decimal=","
                        />
                      </b>
                      <span className="text-black-50">
                        {translate('electedofficial')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3}>
              <Card className="mb-5 card-box card-box-border-bottom border-success">
                <CardContent>
                  <div className="text-center">
                    <div className="mt-1">
                      <City className="font-size-xxl text-info" />
                    </div>
                    <div className="mt-3 line-height-sm">
                      <b className="font-size-lg pr-1">
                        <CountUp
                          start={0}
                          end={516}
                          duration={10}
                          delay={2}
                          separator=","
                          decimals={0}
                          decimal=","
                        />
                      </b>
                      <span className="text-black-50">
                        {translate('cities')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  )
}

export default ResidentNumbers
